module.exports = __webpack_public_path__ + "img/icon-9.e5daaade.png";